var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadlockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44 -503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5-7H4.75V-9.25A4.756,4.756,0,0,0,0-14,4.756,4.756,0,0,0-4.75-9.25V-7H-5.5A1.5,1.5,0,0,0-7-5.5v6A1.5,1.5,0,0,0-5.5,2h11A1.5,1.5,0,0,0,7,.5v-6A1.5,1.5,0,0,0,5.5-7ZM2.25-7h-4.5V-9.25A2.253,2.253,0,0,1,0-11.5,2.253,2.253,0,0,1,2.25-9.25Z",
    transform: "translate(51 517)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIcon);
export default __webpack_public_path__ + "static/media/padlock-icon.08eecddd45023848a4924f9e5e54a42e.svg";
export { ForwardRef as ReactComponent };